import { NgModule, Injector } from '@angular/core';
import { CommonModule, LOCATION_INITIALIZED } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgSelectModule } from '@ng-select/ng-select';
import { AppSettings } from './app-settings';
import { MarkAsteriskDirective } from './mark-asterisk-directive';
import { AutoResizeTextareaDirective } from './auto-resize-textarea.directive';
import { ActivateService } from '../services/activate-service';
import { InputMaskModule } from '@ngneat/input-mask';
import { SmartGridComponent } from './smart-grid/smart-grid.component';
import { SmartGridCellDirective } from './smart-grid/smart-grid-cell.directive';
import { SmartGridEditDirective } from './smart-grid/smart-grid-edit.directive';
import { ScheduleGridComponent } from './schedule-grid/schedule-grid.component';
import { ScheduleGridCellDirective } from './schedule-grid/schedule-grid-cell.directive';
import { FormatTimePipe } from './pipes/format-time.pipe';
import { ToDatePipe } from './pipes/to-date.pipe';
import { BudgetCardComponent } from './budget-card/budget-card.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient],
      },
    }),
    NgSelectModule,
    InputMaskModule,
    SmartGridComponent,
    SmartGridCellDirective,
    SmartGridEditDirective,
    ScheduleGridComponent,
    ScheduleGridCellDirective,
    BudgetCardComponent,
  ],
  declarations: [MarkAsteriskDirective, AutoResizeTextareaDirective, FormatTimePipe, ToDatePipe],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgSelectModule,
    MarkAsteriskDirective,
    AutoResizeTextareaDirective,
    FormatTimePipe,
    ToDatePipe,
    SmartGridComponent,
    SmartGridCellDirective,
    SmartGridEditDirective,
    ScheduleGridComponent,
    ScheduleGridCellDirective,
    BudgetCardComponent,
  ],
  providers: [ActivateService],
})
export class SharedModule {}

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function appInitializerFactory(translate: TranslateService, injector: Injector) {
  return () => new Promise<any>((resolve: any) => {
    const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
    locationInitialized.then(() => {
      var user = JSON.parse(localStorage.getItem(AppSettings.StorageKeys.User));
      const langToSet = user && user.userLanguage != "" ? user.userLanguage.trim().toLowerCase() : 'no'
      translate.setDefaultLang(langToSet);
      translate.use(langToSet).subscribe(() => {
        resolve(null);
      });
    });
  });
}